import { Component, OnInit, Input } from '@angular/core';
import { state, trigger, style, animate, transition} from '@angular/animations';

@Component({
	selector: 'app-expand-collapse',
	template: `
		<div [@state]="state" class="app-expand-collapse">
			<ng-content></ng-content>
		</div>
	`,
	animations: [
		trigger('state', [
			state(
				'expanded',
				style({
					height: '*'
				})
			),
			state(
				'collapsed',
				style({
					height: 0
				})
			),
			transition('expanded => collapsed', animate('300ms ease-in')),
			transition('collapsed => expanded', animate('300ms ease-out'))
		])
	]
})
export class ExpandCollapseComponent implements OnInit {
	@Input()
	state: 'expanded' | 'collapsed' = 'collapsed';

	constructor() {}

	ngOnInit() {}
}
